import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, Route } from 'react-router-dom';
import Loader from 'react-loader-spinner';

import SideBar from 'components/SideBar';
// Transactions
import TransactionPage from 'pages/finance/transactions/main';
import TransactionDetails from 'components/Transactions/TransactionDetails';

import EFakturPage from 'pages/finance/efaktur/EFakturPage';
import CreateTransactionPage from 'components/Transactions/create-transaction';
import CreatePromoPage from 'components/Transactions/create-promo';
import AdminFinanceManagePayment from 'pages/finance/payments/PaymentPage';
import AdminFinancePurchaseOrderNew from 'pages/finance/purchaseOrder/PurchaseOrderPage';

import AdminAccountingPosting from 'components/AdminAccountingPosting';
import AdminFinanceMasterTujuanPengeluaran from 'components/AdminFinanceMasterTujuanPengeluaran';
import AdminFinanceMasterTujuanPenerimaan from 'components/AdminFinanceMasterTujuanPenerimaan';

// Programs
import ProgramHeaderForm from 'components/Programs/ProgramHeaderForm';
import ProgramPage from 'components/Programs/ProgramPage';
import ProgramDetails from 'components/Programs/ProgramDetails';

// Reports
import FinanceReportPage from 'components/Report/FinanceReportPage';
import SalesReportPage from 'pages/reports/salesreport';
import AccountingSalesReportPage from 'pages/reports/accountingsalesreport';
import ProgramSalesReportPage from 'pages/reports/programsalesreport';
import BankReportPage from 'pages/reports/bankeport/BankReportPage';
import AdminReportsEnquiries from 'pages/reports/enquiryreport';

// Accounting
import AdminAccountingGLGenerator from 'components/AdminAccountingGLGenerator';
import GLJournalPage from 'pages/accounting/gljournal/GLJournalPage';

import EDCJournalPage from 'components/EDCJournal/EDCJournalPage';
import AttendeesPage from 'pages/programs/attendees/AttendeesPage';

const AdminPage = (props) => {
  const auth = useSelector((state) => state.auth);
  const { match } = props;
  const { path } = match;

  if (!auth.tokenChecked) {
    return (
      <div className="row h-100">
        <div className="col h-100">
          <div className="d-flex flex-column justify-content-center align-items-center w-100 h-100">
            <Loader type="ThreeDots" color="#53b59f" height={40} width={40} />
          </div>
        </div>
      </div>
    );
  }

  if (auth.isAdmin) {
    return (
      <div>
        <SideBar />
        <div
          style={{ minHeight: '95vh', backgroundColor: '#e3e3e3' }}
          id="db-body"
        >
          <Route
            path={`${path}/purchase-order`}
            component={AdminFinancePurchaseOrderNew}
          />
          <Route
            path={`${path}/payment`}
            component={AdminFinanceManagePayment}
          />
          <Route path={`${path}/efaktur`} component={EFakturPage} />
          <Route
            path={`${path}/master-tujuan-pengeluaran`}
            component={AdminFinanceMasterTujuanPengeluaran}
          />
          <Route
            path={`${path}/master-tujuan-penerimaan`}
            component={AdminFinanceMasterTujuanPenerimaan}
          />
          <Route path={`${path}/edc-journal`} component={EDCJournalPage} />
          <Route
            path={`${path}/general-ledger-generator`}
            component={AdminAccountingGLGenerator}
          />
          <Route
            path={`${path}/general-ledger-journal`}
            component={GLJournalPage}
          />
          <Route
            path={`${path}/accounting-posting`}
            component={AdminAccountingPosting}
          />
          <Route
            path={`${path}/enquiries-reports`}
            component={AdminReportsEnquiries}
          />
          <Route path={`${path}/sales-reports`} component={SalesReportPage} />
          <Route
            path={`${path}/accounting-sales-report`}
            component={AccountingSalesReportPage}
          />
          <Route
            path={`${path}/program-sales-reports`}
            component={ProgramSalesReportPage}
          />
          <Route path={`${path}/bank-reports`} component={BankReportPage} />
          <Route
            path={`${path}/finance-reports`}
            component={FinanceReportPage}
          />
          <Route path={`${path}/transactions`} component={TransactionPage} />
          <Route
            path={`${path}/transaction-details`}
            component={TransactionDetails}
          />
          <Route
            path={`${path}/program-headers`}
            component={ProgramHeaderForm}
          />
          <Route
            path={`${path}/create-transaction`}
            component={CreateTransactionPage}
          />
          <Route path={`${path}/promo`} component={CreatePromoPage} />
          <Route path={`${path}/programs`} component={ProgramPage} />
          <Route
            path={`${path}/program-details/:id`}
            component={ProgramDetails}
          />
          <Route
            path={`${path}/create-program`}
            component={ProgramHeaderForm}
          />
          <Route path={`${path}/attendees`} component={AttendeesPage} />
        </div>
      </div>
    );
  }
  return <Redirect to="/" />;
};

export default AdminPage;
